export default __webpack_public_path__ + "static/3-20af67ff7a3bb0a8b7073ae1c75a2770.png";